<div class="users-container">
  <div class="header">
    <h2>Gestion des Utilisateurs</h2>
    <button *ngIf="hasAnyPermission(['create_users'])" class="btn btn-primary" (click)="addUser()">
      Ajouter un administrateur
    </button>
  </div>

  <div class="loader-container" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Chargement...</span>
    </div>
  </div>

  <table class="users-table" *ngIf="!loading">
    <thead>
      <tr>
        <th>ID</th>
        <th>Nom complet</th>
        <th>Email</th>
        <th>Téléphone</th>
        <th>Rôle</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td>#{{user.id}}</td>
        <td>{{user.prenom}} {{user.nom}} {{user.postnom}}</td>
        <td>{{user.email}}</td>
        <td>{{user.telephone}}</td>
        <td>
          <div class="permissions-list">
            <span class="permission-tag" *ngFor="let role of user.roles">
              {{role.display_name}}
            </span>
          </div>
        </td>
        <td>
          <span [class]="'status ' + user.status">
            {{user.status}}
          </span>
        </td>
        <td class="actions">
          <button *ngIf="hasAnyPermission(['edit_users'])" class="btn btn-sm btn-primary" (click)="editUser(user)">
            <i class="fas fa-edit"></i>
          </button>
          <button *ngIf="hasAnyPermission(['delete_users'])" class="btn btn-sm btn-danger" (click)="deleteUser(user)">
            
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div> 